class ModalOptions {
  Type: string;

  constructor (type: string) {
    this.Type = type
  }
}

export default ModalOptions
